import locales from '../../locales.json';

export const STATUS = {
  UNAUTHORIZED: "unauthorized",
  AUTHORIZED: "authorized",
  OTP_READY: "otp_ready",
  ERROR: "error",
  NOT_FOUND: "not_found",
  ASSIGNED_WITH_EMAIL: "assigned_with_email",
  NEW: "new",
  ASSIGNED_NO_EMAIL: "assigned_no_email",
  CREATED: "created",
};

export const COUNTRIES = {
  SK: { code: 'sk', name: 'Slovensko' },
  CZ: { code: 'cz', name: 'Česko' },
};

export const GENDER_OPTIONS = [
  { value: '', label: 'Žiadne oslovenie' },
  { value: 2, label: 'Pani' },
  { value: 1, label: 'Pán' }
];

export const AGREEMENT_ESHOP_ID = '84d7313c84b270aa5893770d53'

export const FORM_FIELDS = [
  { name: 'gender', label: 'Oslovenie', placeholder: 'Vyberte oslovenie', component: 'select', options: GENDER_OPTIONS, defaultValue: '' },
  { name: 'first_name', label: 'Meno', placeholder: 'Zadajte meno', component: 'input' },
  { name: 'last_name', label: 'Priezvisko', placeholder: 'Zadajte priezvisko', component: 'input' },
  { name: 'email', label: 'E-mail', placeholder: 'Zadajte váš e-mail', component: 'input', type: 'email' },
  { name: 'phone', label: 'Telefónne číslo', placeholder: 'Zadajte vaše tel. číslo', component: 'phone', type: 'tel' },
  { name: 'street', label: 'Ulica a číslo', placeholder: 'Zadajte ulicu a číslo', component: 'street' },
  { name: 'zip', label: 'PSČ', placeholder: 'Zadajte vaše PSČ', component: 'input', maxLength: 6, isZip: true },
  { name: 'city', label: 'Mesto', placeholder: 'Zadajte vaše mesto', component: 'input' },
  { name: 'country', label: 'Štát', placeholder: 'Vyberte váš štát', component: 'select', options: Object.values(COUNTRIES) },
  { name: 'birth_date', label: 'Dátum narodenia', placeholder: 'DD.MM.RRRR', component: 'datepicker' },
];

export const {
  FORM_TEXTS,
  HEADER_TEXTS,
  FOOTER_TEXTS,
  CARD_VERIFICATION_TEXTS,
  OTP_VERIFICATION_TEXTS,
  DASHBOARD_TEXTS,
  CONTACTS,
} = locales;
